import React from "react";
import { MultiColumnList } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var ProductExtentsTable = function (_a) {
    var extents = _a.extents;
    var formatMessage = useIntl().formatMessage;
    var extentsData = extents.map(function (extent, index) {
        var _a, _b, _c;
        return ({
            id: extent.id || index.toString(),
            type: ((_a = extent.type) === null || _a === void 0 ? void 0 : _a.description) || "-",
            value: ((_b = extent.value) === null || _b === void 0 ? void 0 : _b.toString()) || "-",
            unit: ((_c = extent.unit) === null || _c === void 0 ? void 0 : _c.description) || "-",
        });
    });
    var columnMapping = {
        id: "ID",
        type: formatMessage({ id: "ui-br-agency.product.extent.type.label" }),
        value: formatMessage({ id: "ui-br-agency.product.extent.value.label" }),
        unit: formatMessage({ id: "ui-br-agency.product.extent.unit.label" }),
    };
    var visibleColumns = [
        "type",
        "value",
        "unit",
    ];
    return (React.createElement(MultiColumnList, { contentData: extentsData, visibleColumns: visibleColumns, columnMapping: columnMapping, interactive: false, columnWidths: {
            type: "40%",
            value: "30%",
            unit: "30%",
        } }));
};
